export enum IItemScratchPadChangeEventType {
  Created = 1,
  Deleted = 2
}